// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__s-t1W","requiredAsterisk":"Info_requiredAsterisk__25PkN"};